import React, { Component } from 'react'
import './style.css'
import { Link } from 'react-router-dom'


export default class NavBar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            navMenuVisible: false
        }
    }

    componentWillMount() {
        document.addEventListener('touchend', this.onNavMenuBlur, false)
        document.addEventListener('mousedown', this.onNavMenuBlur, false)
        window.addEventListener('resize', this.onWindowResize)
    }

    componentWillUnmount() {
        document.removeEventListener('touchend', this.onNavMenuBlur, false)
        document.removeEventListener('mousedown', this.onNavMenuBlur, false)
        window.removeEventListener('resize', this.onWindowResize)
    }   

    onNavMenuBlur = (e) =>{
        if(this.menuRef && !this.menuRef.contains(e.target)) {
            this.setState({navMenuVisible: false})
        }
    }

    onWindowResize = () =>{
        this.setState({navMenuVisible: false})
    }

    showCard = () => {
        this.props.showCard()
        this.setState({navMenuVisible: false})
    }
    
    aboutLinkText = () => {
        switch(this.props.language) {
            default:
                return 'About'
        }
    }

    homeLinkText = () => {
        switch(this.props.language) {
            default:
                return 'Home'
        }
    }

    tipsLinkText = () => {
        switch(this.props.language) {
            default:
                return 'Tips'
        }
    }

    socialLinkText = () => {
        switch(this.props.language) {
            default:
                return 'Social'
        }
    }

    contactLinkText = () => {
        switch(this.props.language) {
            default:
                return 'Contact'
        }
    }

    render() {
        return(
            <nav className={'navbar-navbar'}>
                <div className={'guard-navbar'} style={{display: this.state.navMenuVisible ? 'block' : 'none'}}/>
                
                <Link to={'/'} className={'logo-navbar'}>Just legal</Link>

                <button className={'dropDownButton-navbar'} onClick={() => {this.setState({navMenuVisible: true})}}/>
                <div className={'links-navbar ' + (this.state.navMenuVisible ? 'showLinks-navbar' : '')}
                ref={(ref) => this.menuRef=ref}>

                    <Link to={'/'} className={'link-navbar ' + (this.props.page === 'home' ? 'onLink-navbar' : '')}> {this.homeLinkText()} </Link>
                    <button className={'buttonLink-navbar link-navbar'} onClick={() => {this.showCard()}}> {this.aboutLinkText()} </button>
                    <Link to={'/tips'} className={'link-navbar ' + (this.props.page === 'tips' ? 'onLink-navbar' : '')}> {this.tipsLinkText()} </Link>
                    <Link to={'/social'} className={'link-navbar ' + (this.props.page === 'social' ? 'onLink-navbar' : '')}> {this.socialLinkText()} </Link>
                    <Link to={'/contact'} className={'link-navbar ' + (this.props.page === 'contact' ? 'onLink-navbar' : '')}> {this.contactLinkText()} </Link>

                </div>
            </nav>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/components/navBar/navBar.js